import FakeChat from "./FakeChat";
import { chatFrameHandler } from "../../../Assets/Js/ChatFrameHandler";

if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

import InstantChat from "./InstantChat";
import VideoPlayer from "./VideoPlayer";
import HostLine from "./Hostline";
import VideoCam from "./Videocam";
import * as helper from "./../../../Assets/Js/helper";
import * as Events from "./Events";
import ChatBox from "./Chatbox";
import ButtonHandler from "./ButtonHandler";
import SignupHandler from "./SignupHandler";

helper.onDocumentLoaded(function () {
	const $information = helper.$("#information");

	const ab6 = parseInt(helper.getData($information, "ab6"));
	let pfm = helper.getData($information, "pfm");
	let pt = helper.getData($information, "pt");
	let maxVideos = helper.getData($information, "maxvideos");
	let starterVideo = JSON.parse(helper.getData($information, "startervideo"));
	let ab3 = parseInt(helper.getData($information, "ab3"), 10);

	let ChatHandler = new InstantChat(maxVideos);

	let hostVideo = new VideoPlayer(ChatHandler.random.bind(ChatHandler));
	let videoElementGuest = helper.$("#videoContainerGuest");
	let videoButtonGuest = helper.$("#videoButtonGuest");
	let videoElementHost = helper.$("#videoContainerHost");
	let inputField = helper.$("#nachricht");

	helper.addEventListener(window, Events.START_ACTION, () => {
		if (starterVideo !== null) {
			helper.triggerEvent(window, Events.VIDEO_CHANGED, starterVideo);
		} else {
			ChatHandler.random();
		}
		helper.addEventListener(window, Events.SHOW_NEXT_GIRL, () => {
			ChatHandler.random();
		});
	});

	helper.addEventListener(window, Events.VIDEO_CHANGED, function (event) {
		hostVideo.load(event.detail.url);
		videoElementHost.dataset["hostname"] = event.detail.name;
		videoElementHost.dataset["uid"] = event.detail.uid;
		videoElementHost.dataset["age"] = event.detail.age;
	});

	new HostLine();
	new VideoCam(videoElementGuest);
	new SignupHandler(pfm, ab3, pt);

	if (helper.getData($information, "ab2") === "1") {
		new FakeChat(helper.$("#commentbox"));
	} else {
		let chatbox = new ChatBox(helper.$("#commentbox"), inputField, helper.$(".sendbtn")[0]);
		window.addEventListener("resize", function () {
			chatbox._positionBox();
		});
	}

	chatFrameHandler(ab6);
	new ButtonHandler(helper.$("#next"), helper.$("#chat"), videoButtonGuest, helper.$("#cta"));
});
